import { Injectable } from '@angular/core';

import { ListResponse } from '../../models/list-response';

import { TaxRate } from '../../models/tax-rate';
import { ApiService } from '../api/api.service';

@Injectable({
  providedIn: 'root'
})
export class TaxRateService {
  /**
   * A service providing access to tax rates via the API.
   */

  constructor(
    private apiService: ApiService
  ) {}

  /**
   * Get a page of tax rates from the API.
   *
   * @param pageNumber - The requested page number.
   * @param pageSize - The requested number of tax rates per page.
   * @return The list of tax rates.
   */
  getTaxRates(pageNumber?: number,
              pageSize?: number): Promise<ListResponse<TaxRate>> {
    return this.apiService.getCollectionNoFilters<TaxRate>(
      'tax-rates/',
      pageNumber,
      pageSize
    );
  }

  /**
   * Post a new tax rate to the API.
   *
   * @param taxRate - The new TaxRate object to create.
   * @return The new tax rate returned from the API.
   */
  addTaxRate(taxRate: TaxRate): Promise<TaxRate> {
    return this.apiService.postToAPI<TaxRate>(
      'tax-rates/',
      {
        name: taxRate.name,
        rate_percent: taxRate.rate_percent
      }
    );
  }

  /**
   * Update a tax rate by making a PUT request to the API.
   *
   * @param taxRate - The tax rate, with updated values.
   * @return The updated tax rate returned from the API.
   */
  updateTaxRate(taxRate: TaxRate): Promise<TaxRate> {
    return this.apiService.putToAPI<TaxRate>(
      taxRate.url,
      taxRate
    );
  }

  /**
   * Delete a tax rate by making a DELETE request to the API.
   *
   * @param taxRateUrl - The API URL of the tax rate to delete.
   * @return A promise which resolives when the tax rate is deleted.
   */
  deleteTaxRate(taxRateUrl: string): Promise<void> {
    return this.apiService.deleteFromAPI<any>(
      taxRateUrl
    ).then();
  }
}
